module.exports = __webpack_public_path__ + "media/images/appfolio-logo-1ebdc56901f32825007c2076b6e9db44.png";